import scenariosJson from "./data/scenarios.json";
import secondariesJson from "./data/secondaries.json";
import scoringPacksJson from "./data/scoring-packs.json";

export const scenarios = scenariosJson.scenarios;
export const secondaries = secondariesJson.secondaries;
export const scoringPacks = scoringPacksJson.packs;

export const getScenario = (id) => scenarios.find((s) => s.id === id);
export const getScoringPack = (id) => scoringPacks.find((p) => p.id === id);
export const getSecondary = (id) => secondaries.find((s) => s.id === id);
